import e from "react";
const n = ({ id: t, ...r }) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    ...r
  },
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "pattern",
    {
      id: `pattern_${t}`,
      patternUnits: "userSpaceOnUse",
      width: "5.5",
      height: "5.5",
      patternTransform: "rotate(135)"
    },
    /* @__PURE__ */ e.createElement("line", { x1: "0", y: "0", x2: "0", y2: "5.5", stroke: "#9D77F0", strokeWidth: "3" })
  )),
  /* @__PURE__ */ e.createElement("rect", { width: "100%", height: "100%", fill: `url(#pattern_${t})` })
);
export {
  n as default
};
//# sourceMappingURL=index.es157.js.map
